var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.4179C42.0379 53.4179 53.4179 42.0379 53.4179 28C53.4179 13.9621 42.0379 2.58212 28 2.58212C13.9621 2.58212 2.58212 13.9621 2.58212 28C2.58212 42.0379 13.9621 53.4179 28 53.4179ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.4179C42.0379 53.4179 53.4179 42.0379 53.4179 28C53.4179 13.9621 42.0379 2.58212 28 2.58212C13.9621 2.58212 2.58212 13.9621 2.58212 28C2.58212 42.0379 13.9621 53.4179 28 53.4179ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "white",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 48.5333C39.3404 48.5333 48.5335 39.3402 48.5335 28C48.5335 16.6598 39.3404 7.46667 28.0001 7.46667C16.6599 7.46667 7.4668 16.6598 7.4668 28C7.4668 39.3402 16.6599 48.5333 28.0001 48.5333ZM35.107 18.6667L24.9205 29.0216L20.6057 24.6354L16.8001 28.5039L24.9205 36.7586L38.9125 22.5352L35.107 18.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 48.5333C39.3404 48.5333 48.5335 39.3402 48.5335 28C48.5335 16.6598 39.3404 7.46667 28.0001 7.46667C16.6599 7.46667 7.4668 16.6598 7.4668 28C7.4668 39.3402 16.6599 48.5333 28.0001 48.5333ZM35.107 18.6667L24.9205 29.0216L20.6057 24.6354L16.8001 28.5039L24.9205 36.7586L38.9125 22.5352L35.107 18.6667Z",
    fill: "#2E7D32",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success-white.cb3117d2acf35eb9e0ec12790b49a0e7.svg";